<template>
    <div class="uk-margin-small-bottom uk-margin-small-top coupon-wrapper">
        <label for="couponCode">
            {{ $t('Einen Coupon / Code hier eingeben') }}:
        </label>
        <div class="uk-form-controls uk-margin-small-top" uk-grid>
            <div class="uk-width-expand uk-margin-right">
                <input @keydown.enter="checkCoupon" :disabled="couponChecking" id="couponCode" v-model="couponCode" class="uk-input" type="text" :placeholder="$t('Gutschein-Code')">
            </div>
            <button :disabled="couponChecking" class="uk-button uk-button-primary check-button" @click="checkCoupon">
                {{ $t("Jetzt prüfen") }}
            </button>
            <div v-if="couponResponse" style="flex-basis:100%; margin-top: 15px" v-html="couponResponse">
            </div>
        </div>
    </div>
</template>

<script>
import helper from "../../helper/helper";

export default {
    mixins: [helper],
    props: ["settings"],
    data: () => {
        return {
            couponChecking: false,
            couponResponse: '',
        }
    },
    computed: {
        couponCode: {
            get() {
                return this.store.state.couponCode;
            },
            set(newValue) {
                this.store.state.couponCode = newValue;
            },
        },
    },
    mounted() {
        // A code the buyer arrived with (?coupon=CODE, or the embed handing it on) is
        // checked without a click — the products a coupon unlocks would otherwise stay
        // invisible and the link would buy him nothing. `couponChecked` keeps it at one
        // check: stepping back to the ticket list remounts this component with the code
        // still in the store, and a code already checked needs no second round trip.
        if (this.couponCode && !this.store.state.couponChecked) {
            this.checkCoupon()
        }
    },
    methods: {
        checkCoupon(state) {
            this.store.state.couponChecked = true
            this.couponChecking = true
            this.couponResponse = this.$t('Lädt..')
            this.doOctoberRequest("onInitialCouponCheck", {code: this.couponCode}).then(response => {
                if (response.length == 0) {
                    this.couponResponse = this.$t('Coupon-Code nicht gefunden oder nicht mehr gültig.');
                    setTimeout(() => {this.couponChecking = false}, 2000)
                    return
                }
                this.couponResponse = this.$t('Code wurde gefunden!')
                this.store.state.couponCode = this.couponCode
                this.store.state.couponSwitch = true
                if (response.couponWithValue) {
                    this.couponResponse += '<br>'+this.$t('Der Rabatt wird vor Kaufabschluss angezeigt.')
                }
                if (response.offers) {
                    if (response.couponWithValue) {
                        this.couponResponse +=' ('+this.$t('Reduzierte Produkte sind hervorgehoben.')+')'
                    }
                    this.couponResponse += '<br>'+this.$t('Es werden zusätzliche Produkte angezeigt.')
                    this.store.commit("updateOffers", response)
                    const initialOfferId = response.initialOfferId;
                    this.$emit('coupon-found', initialOfferId)
//                    setTimeout(() => {this.couponChecking = false}, 2000)
                }
            }).catch(_ => {
                this.couponResponse = ''
                this.couponChecking = false
            })
        },
    },
};
</script>
